import MultipleOfferTemplate from '../../component/template/MultipleOfferTemplate'
import Webview from '../../component/native/visible/Webview'
import Message from '../../Message'
import App from '../../App'
import { report } from '../../../common/decorators'
import {
  reportBizAddRewardToServer,
  reportBizAdTrackingClick,
  reportBizAdTrackingEndcardShow,
  reportBizAdTrackingImpression,
  reportBizAdTrackingVideoClose,
  reportBizAdTrackingVideoComplete,
  reportBizAdTrackingVideoFirstQuartile,
  reportBizAdTrackingVideoMidpoint,
  reportBizAdTrackingVideoMute,
  reportBizAdTrackingVideoPlayPercentage,
  reportBizAdTrackingVideoStart,
  reportBizAdTrackingVideoThirdQuartile,
  reportBizAdTrackingVideoUnmute,
  reportBizImpression,
} from '../../../common/m_common/mBizReport'
import {presetOnlyImpression, presetPvUrls} from '../../../common/m_common/mBizReportPreset'
import {reportNonBizData} from "../../../common/m_common/mNonBizReport";
import {
  presetBtShow,
  presetBtClose,
  presetBtEndcardShowFailed,
  presetBtInitSDKVersionEmpty,
  presetBtWebviewTerminate,
  presetBtAdShowFailed,
  presetBtRPDialogClick,
  presetBtRPDialogFailedClose,
  presetBtRPDialogCollapse,
  presetBtRPDialogExpand,
} from '../../../common/m_common/mNonBizReportPreset'
import {VideoBridgeGetFileInfo} from "../../../api"
import NativeEndcard from '../../component/native/visible/NativeEndcard'
import * as Tools from '../../../common/tool'

let currentCampaign = {}

export default class RewardPlusTemplate extends MultipleOfferTemplate {
  constructor(props = {}) {
    super(props)
    this.initCLengthTimingReport()
    this.currentOffer = this.campaignList[0]
    currentCampaign = this.currentOffer

    // endcard是否已就绪
    this.endcardHasReady = false
    // 是否已给奖励回调
    this.hasBeenReward = false
    // 初始上报进度
    this.lastVideoPlayPercentage = 0
    // 运行一次标志
    this.hasRunOneTime = false
    // 是否给奖励回调,默认为2，不给奖励回调，1，给奖励，根据unitSetting.vdcmp判断当前播放进度是否达到
    this.convert = 2
    // 奖励值矩阵
    this.rewardValueArray = [Math.min(App.initData.unitSetting.amount, App.initData.unitSetting.amount_max), Math.min(App.initData.unitSetting.amount * 2, App.initData.unitSetting.amount_max)]

    // 检查当前 initData 中的 sdk_info 是否为空，如果为空则显式抛出错误，上报特殊埋点，并直接通知 SDK not ready
    this.checkIfSDKVersionEmpty();

    this.videoInterType = (App.initData.unitSetting.video_interactive_type && parseInt(App.initData.unitSetting.video_interactive_type, 10)) || 0
    console.log('videoInterType:', App.initData.unitSetting.video_interactive_type, this.videoInterType)

    this.videoSkipResult = (App.initData.unitSetting.video_skip_result && parseInt(App.initData.unitSetting.video_skip_result, 10)) || 2
    console.log('videoSkipResult:', App.initData.unitSetting.video_skip_result, this.videoSkipResult)

    this.videoHasEndOrSkip = false

    // 静音状态用户针对每个视频的首次切换上报，切换offer时重新初始化
    this.muteReportHasSent = false
    this.unmuteReportHasSent = false

    // 关闭弹窗已出现？
    this.popupHasShow = false

    // ec加载是否成功？ IOS 590-620不可用，已通过联合this.endcardHasReady判断进行兼容
    this.endcardHasLoadedSuccess = false

    // offer已更换？
    this.offerHasChanged = false

    // rp弹窗展开状态
    this.nextOfferChoiceHasExpand = true

    // rp弹窗已出现？
    this.rpDialogHasMount = false

    this.rewardInfoIsNotNull = App.initData.unitSetting.callback_rule && App.initData.unitSetting.virtual_currency && App.initData.unitSetting.currency_id && App.initData.unitSetting.name && App.initData.unitSetting.amount && App.initData.unitSetting.amount_max
    
    // 下一个tpl1已就绪？
    this.nextOfferHasReady = false

    // 记录奖励次数
    this.rewardTimesCount = 0
  }

  /**
   * 检查当前 initData 中的 sdk_info 是否为空，如果为空则显式抛出错误，上报特殊埋点，并直接通知 SDK not ready
   */
  checkIfSDKVersionEmpty() {
    let currentSDKVersion = App && App.initData && (App.initData.sdk_info || App.initData.appSetting && App.initData.appSetting.sdk_info) || ''
    if (currentSDKVersion === '') {
      console.error('currentSDKVersion 为空，无法判断当前 SDK 版本，请检查：', currentSDKVersion, App)
      this.initSDKVersionEmptyTimingReport()
      App.failureToShowAD()
    } else {
      console.log('currentSDKVersion 非空，不影响 WindVane 版本判断，检查通过：', currentSDKVersion, App)
    }
  }

  async adShowed(data) {
    super.adShowed(data)
    // Template基类中已对this.reward根据show时传入的奖励信息进行了初始化，但rp模板较特殊，故重新初始化
    this.reward = {
      amount: this.rewardValueArray[0],
      id: App.initData.unitSetting.currency_id,
      name: App.initData.unitSetting.name,
    }
    setTimeout(() => {
      this.resetSlotRectById('slot_2')
    }, 500)

    // 初始化奖励信息 rewardInfo
    this.platform.setRewardInfo(data)

    this.h5Setting = Tools.getAdStatus({
      ...App.initData,
      adShowTime: App.adShowTime
    })

    // 广告展示时，在 h5Setting 初始化之后，进行任何展示逻辑之前：
    // 检查 campaignList 中的视频资源是否下载完成，如果有任一资源不满足，则直接 showfailed
    if (!await this.isAllCampaignVideoDownloaded(this.campaignList)) {
      this.closeAdWithShowFailedBiz();
      return false
    }

    // 展示成功 进行 onlyImpression 节点的相关上报，
    // 注意：以 onlyImpression 为起点的所有业务上报依赖 h5Setting 初始化，所以相关上报需要放在 h5Setting 初始化之后调用
    this.onlyImpressionTimingReport()
    // 调用回调/扣回调方法
    this.platform.callReactDeveloper({
      ...App.initData,
      ...this.h5Setting,
      campaign:this.currentOffer,
      nodeName:"showSuccess",
      adShowTime:App.adShowTime
    })
    // 调用自动load方法
    this.platform.callLoadAds({
      ...App.initData,
      campaign:this.currentOffer,
      nodeName:"showSuccess",
    })

    // webview 被系统回收时上报 webviewTerminate 埋点，并直接关闭广告
    this.handelWebviewTerminateEventAfterShow();

    this.platform.onSystemPause(() => {
      console.log('切换到后台，暂停视频')
      Message.emitMessageToView(this.currentOffer.getTemplate(), 'pausePlay')
    })

    this.platform.onSystemResume(() => {
      console.log('切回AD')
      if (!this.videoHasEndOrSkip && !this.popupHasShow) {
        console.log('切回AD，Video TPL没结束，继续')
        Message.emitMessageToView(this.currentOffer.getTemplate(), 'resumePlay')
      }
    })

    Message.emitMessageToView(this.currentOffer.getTemplate(), 'resumePlay')

    if (this.videoInterType > 0) {
      this.ctaBannerDelayTimerId = setTimeout(() => {
        Message.emitMessageToView(this.currentOffer.getTemplate(), 'showCtaBanner')
      }, this.videoInterType * 1000)
    }

    // 方向改变时对当前已显示webview进行调整
    this.platform.onOrientationChange(() => {
      console.log('监听到屏幕方向改变事件，执行重渲染')
      this.resetSlotRectById('slot_1')
      if (this.rpDialogHasMount) {
        this.resetSlotRectById('slot_2')
      }
    })
  }

  /**
   * show 时进行任何展示逻辑之前检查 campaignList 中的视频资源是否下载完成，如果有任一资源不满足，则直接 showfailed
   * @param {object[]} campaignList 要检查的 campaign 列表
   * @returns {Promise<boolean>} true 表示所有视频资源都已下载完成，否则返回 false
   */
  async isAllCampaignVideoDownloaded(campaignList = []) {
    if (typeof campaignList === 'undefined' || campaignList.length <= 0) {
      console.error('当前要检查的 campaign 列表为空，直接 pre check 失败')
      return false
    }

    // 默认会先认为 show 之前的所有 video 资源都是已下载完毕的
    let isAllVideoDownloaded = true
    let params = {
      unitId: this.unit.id,
      resource: []
    }
    campaignList.forEach((campaign, i) => {
      let resourceItem = {type: 1, ref: `${campaign && campaign.video_url}`};
      console.log({resourceItem})
      params.resource[i] = resourceItem
    })
    let res = await VideoBridgeGetFileInfo(params)

    for (let i = 0; i < campaignList.length; i++) {
      // 如果当前 index 之前的 video 检查都通过的话，就继续检查下一个
      if (isAllVideoDownloaded) {
        let campaign = campaignList[i]
        isAllVideoDownloaded = this.isCurrentVideoDownloaded(campaign, res, isAllVideoDownloaded);
      }
    }

    console.log({isAllVideoDownloaded})
    return isAllVideoDownloaded
  }

  /**
   * 判断当前 campaign 下的 video_url 资源是否下载成功
   * @param campaign 必传项，当前要检查的 campaign
   * @param res 必传项，当前 campaign 的 video_url 对应的
   * @param isAllVideoDownloaded
   * @returns {boolean}
   */
  isCurrentVideoDownloaded(campaign, res, isAllVideoDownloaded) {
    let videoRemoteUrl = campaign.video_url;
    let videoLocalUrlList = res && res.resource
    let curVideoLocalUrl = videoLocalUrlList
        && typeof videoLocalUrlList.filter === 'function'
        && videoLocalUrlList.filter(item => item[videoRemoteUrl])[0]
        && videoLocalUrlList.filter(item => item[videoRemoteUrl])[0][videoRemoteUrl]
    if (curVideoLocalUrl && curVideoLocalUrl.downloaded === 1) {
      console.log('当前 campaign 的视频资源已下载成功', {campaign, curVideoLocalUrl})
    } else {
      isAllVideoDownloaded = false
      campaign.isReady = false
      console.error('isAllVideoDownloaded: ', isAllVideoDownloaded)
    }
    console.log('isAllVideoDownloaded: ', isAllVideoDownloaded)
    return isAllVideoDownloaded;
  }

  closeAdWithShowFailedBiz() {
    console.error('当前 campaign 的视频资源没有下载完成或不存在，无法正常展示广告，showfailed')
    // showFailed时机：
    // 单offer,一个视频播放失败或无法播放，
    // 多offer：（多个视频都无法播放或失败），
    // 据产品描述，但凡收到onlyImpression上报就说明展示成功了，就不是showFailed，
    // 需跟康康确认onlyimpression上报是否根据视频播放失败来判断
    // 调用回调/扣回调方法
    this.platform.callReactDeveloper({
      ...App.initData,
      ...this.h5Setting,
      campaign: this.currentOffer,
      nodeName: "showFailed",
      adShowTime: App.adShowTime,
      error: {
        code: 12930007,
        msg: "kMTGErrorCodeFailedToShow"
      }
    })
    // 调用自动load方法
    this.platform.callLoadAds({
      ...App.initData,
      campaign: this.currentOffer,
      nodeName: "showFailed",
    })
    // showfailed 埋点上报
    this.adShowFailedTimingReport()
    // 强制关闭整个广告
    App.closeAd()
  }

  /**
   * webview 被系统回收时上报 webviewTerminate 埋点，并直接关闭广告
   */
  handelWebviewTerminateEventAfterShow() {
    document.addEventListener('onWebviewTerminate', res => {
      this.webviewTerminateTimingReport()
      this.closeAdWithBiz()
    })
  }

  initComponents() {
    super.initComponents()

    if (!this.campaignList || !this.campaignList[0] || !this.campaignList[1]) {
      this.loadCEmptyTimingReport()
    }
    this.tplContainer = new Webview()
    Webview.getLoadCampaignParams(this.currentOffer.rv.template_url, [this.campaignList[0]], this.unit.id, this.unit.setting)
      .then(loadParams=>{
        console.log('获取到load campaign参数：', loadParams)
        this.tplContainer.load(loadParams)
      })
    this.currentOffer.getTemplate = () => {
      return this.tplContainer
    }

    this.endcard = new Webview()
    Webview.getLoadCampaignParams(this.currentOffer.endcard_url, [this.campaignList[0]], this.unit.id, this.unit.setting)
      .then(loadParams => {
        console.log('获取到Endcard：', loadParams)
        this.endcard.onLoad((data) => {
          const { result } = data
          if(result === 1) {
            this.endcardHasLoadedSuccess = true
          }
        })
        this.endcard.whenCampaignReady().catch(() => {
          console.log('ecloadfailed')
          this.endcard.destory()
          this.endcardHasLoadedSuccess = false
          this.endcardHasReady = false
        })
        this.endcard.load(loadParams)
      })

    // rp弹窗
    this.nextOfferChoice = new Webview()
    Webview.getLoadCampaignParams(`${Tools.parseDns()}/rewardplus-dialog/rewardplus-dialog.html`, [this.campaignList[1]], this.unit.id, this.unit.setting)
      .then(loadParams=>{
        console.log('获取到load campaign参数(跳转用banner)：', loadParams)
        this.nextOfferChoice.load(loadParams)
      })
  }

  /**
   * 初始化插槽
   */
  initSlots(){
    super.initSlots()
    this.slotIn('slot_1', this.currentOffer.getTemplate())
  }

  bindPageEvent() {
    // Create for endcard close in this tpl
    Message.onSubViewEmitMessage('MTG_TriggerCloseBtn', () => {
      console.log('收到MTG_TriggerCloseBtn——————————————————————————————————')
      this.closeAdWithBiz()
    })

    // Create for endcard click event
    Message.onSubViewEmitMessage('MTG_EndcardAdClick', () => {
      console.log('收到MTG_EndcardAdClick')
      // endcard点击回调
      // 调用回调/扣回调方法
      this.platform.callReactDeveloper({
        ...App.initData,
        ...this.h5Setting,
        campaign:this.currentOffer,
        nodeName:"clicked",
        adShowTime:App.adShowTime,
      })
      // this.clickTimingReport()
    })

    // Get it when endcard ready
    Message.onSubViewEmitMessage('MTG_EndcardHasReady', () => {
      console.log('收到MTG_EndcardHasReady——————————————————————————————————')
      this.endcardHasReady = true
    })

    Message.onSubViewEmitMessage('onCloseBtnClick', (data) => {
      if (data.instanceId == this.currentOffer.getTemplate().getId()) {
        this.videoHasEndOrSkip = true
        this.videoCloseTimingReport()
        Message.emitMessageToView(this.currentOffer.getTemplate(), 'destoryPlayer')
        this.closeSingleVideoTemplateWithAutoJump();
      }

      if (data.instanceId == this.nextOfferChoice.getId()) {
        this.dialogCloseManualTimingReport()
        document.querySelector('#slot_2').style.width = (220/75/2) + 'rem'
        Message.emitMessageToView(this.nextOfferChoice, 'shrinkDialog')
        this.resetSlotRectById('slot_2')
        this.nextOfferChoiceHasExpand = false
      }
    })

    Message.onSubViewEmitMessage('onVideoCurrentTimeChange', (data) => {
      const videoCurrentTime = parseInt(data.currentTime, 10)
      // 在load阶段触发该广播直接无视
      if (videoCurrentTime <= 0)
        return
      
      // 以下为正常业务逻辑，高度依赖videoCurrentTime
      if (!this.hasRunOneTime) {
        this.impressionTimingReport() //每个offer只报一次
        this.videoStartTimingReport() //每个offer只报一次
        reportBizAdTrackingVideoPlayPercentage({
          currentCampaign: this.currentOffer,
          rate: 0
        })

        // 频次信息
        const sendData = this.platform.prepareDataForIncOfferFreRvIv(data.campaign)
        this.platform.increaseOfferFrequenceForRvIv(sendData)

        this.hasRunOneTime = true
      }

      if (data.videoPercentage != this.lastVideoPlayPercentage) {
        const startPoint = this.lastVideoPlayPercentage
        const endPoint = parseFloat(data.videoPercentage) > 0.99 ? 0.99 : parseFloat(data.videoPercentage)

        if (startPoint < 0.25 && 0.25 <= endPoint) {
          this.videoFirstQuartileTimingReport()
        }

        if (startPoint < 0.5 && 0.5 <= endPoint) {
          this.videoMidpointTimingReport()
        }

        if (startPoint < 0.75 && 0.75 <= endPoint) {
          this.videoThirdQuartileTimingReport()
        }

        for (let i = 0.01; startPoint + i <= endPoint; i = i + 0.01) {
          reportBizAdTrackingVideoPlayPercentage({
            currentCampaign: this.currentOffer,
            rate: Math.floor((startPoint + i) * 100)
          })
        }

        console.log("data.videoPercentage",data.videoPercentage)
        this.canGiveRewardToUser(data.videoPercentage)
        this.lastVideoPlayPercentage = endPoint
      }
    })

    Message.onSubViewEmitMessage('onInstallBtnClick', (data) => {
      if (data.instanceId == this.currentOffer.getTemplate().getId()) {
        // ctabanner install点击
        this.platform.clickInstall(
          data.clickEvent,
          {
            autoClick: false,
            template: 'rv',
            subComp: 'ctabanner',
            campaign: this.currentOffer,
          }
        )
        // notice_url拼接相关参数在clickInstall方法中已经拼接且在调用click协议时，sdk已上报，这里暂时不需调用，后续分离出点击方法中的上报，后续康康待增加：notice_url中点击坐标宏替换，af_token替换
        // reportBizNoticeUrl({ currentCampaign: data.campaign })
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
          ...App.initData,
          ...this.h5Setting,
          campaign:this.currentOffer,
          nodeName:"clicked",
          adShowTime:App.adShowTime,
        })
        // this.clickTimingReport()  // click方法里已经上报了adtracking.click,这里暂时不调用，后续康康待增加：af_token替换
      }

      if (data.instanceId == this.nextOfferChoice.getId()) {
        if (this.nextOfferChoiceHasExpand) {
          Message.emitMessageToView(this.nextOfferChoice, 'waitNextOfferReady')
          
          // 根据配置隐藏cta banner
          if (this.videoInterType != 0) {
            Message.emitMessageToView(this.tplContainer, 'hideCtaBanner')
          }

          // 延时执行以解决隐藏cta banner的残影问题
          setTimeout(() => {
            if (this.nextOfferHasReady) {
              this.switchToNextOffer()
              this.nextOfferChoice.destory()
            } else {
              const ps = new Promise((resolve) => {
                this.tplContainer.whenCampaignReady().then(() => {
                  console.log('offer2 加载成功')
                  this.switchToNextOffer()
                  resolve()
                })
              })
              Promise.all([ps])
              setTimeout(() => {
                this.nextOfferChoice.destory()
                if (!this.offerHasChanged) {
                  this.dialogCloseAutoTimingReport()
                }
              }, 9000)
            }
          }, 1000)
        } else {
          this.dialogExpandTimingReport()
          document.querySelector('#slot_2').style.width = (700/75/2) + 'rem'
          Message.emitMessageToView(this.nextOfferChoice, 'expandDialog')
          this.resetSlotRectById('slot_2')
          this.nextOfferChoiceHasExpand = true
        }
      }
    })

    // 视频播放完成
    Message.onSubViewEmitMessage('onVideoEnded', (data) => {
      // 播放进度监听到不了1，所以这里要再判断一次，是否满足奖励回调
      this.canGiveRewardToUser("1")
      this.videoHasEndOrSkip = true
      console.log("视频播放完成,this.convert",this.convert)
      // 调用回调/扣回调方法
      this.platform.callReactDeveloper({
        ...App.initData,
        ...this.h5Setting,
        campaign:this.currentOffer,
        nodeName:"playCompleted",
        adShowTime:App.adShowTime,
      })
      // 调用自动load方法
      this.platform.callLoadAds({
        ...App.initData,
        campaign:this.currentOffer,
        nodeName:"playCompleted",
      })
      this.videoCompleteTimingReport()
      reportBizAdTrackingVideoPlayPercentage({
        currentCampaign: this.currentOffer,
        rate: 100
      })

      // 关闭视频模板，自动走跳转 ec 相关逻辑
      this.closeSingleVideoTemplateWithAutoJump();
    })

    Message.onSubViewEmitMessage('onMuteBtnClick', (data) => {
      if (data.muted && !this.muteReportHasSent) {
        this.videoMuteTimingReport()
        this.muteReportHasSent = true
      } else if (!data.muted && !this.unmuteReportHasSent) {
        this.videoUnmuteTimingReport()
        this.unmuteReportHasSent = true
      }
    })

    if (this.videoInterType == -1) {
      Message.onSubViewEmitMessage('onTplClick', (data) => {
        if (data.hasShown) {
          Message.emitMessageToView(this.currentOffer.getTemplate(), 'hideCtaBanner')
          this.bannerTimerId && clearTimeout(this.bannerTimerId)
          this.bannerTimerId = null
        } else {
          Message.emitMessageToView(this.currentOffer.getTemplate(), 'showCtaBanner')
          this.bannerTimerId = setTimeout(() => {
            Message.emitMessageToView(this.currentOffer.getTemplate(), 'hideCtaBanner')
          }, 3000)
        }
      })
    }

    Message.onSubViewEmitMessage('popupShow', () => {
      if (this.rpDialogHasMount) {
        this.nextOfferChoice.hide()
      } else {
        this.popupHasShow = true
      }
    })

    Message.onSubViewEmitMessage('popupHide', () => {
      if (this.rpDialogHasMount) {
        this.nextOfferChoice.show()
      } else {
        this.popupHasShow = false
      }
    })
  }

  /**
   * 在关闭广告前执行 "开发者奖励回调(callReactDeveloper)、关闭回调（调用closeAd）、自动 load、close 埋点上报" 等逻辑
   */
  closeAdWithBiz() {
    // 广告关闭
    // 调用回调/扣回调方法
    console.log("关闭广告")
    switch(this.rewardTimesCount) {
      case 0:
        this.reward.amount = 0
        break
      case 1:
        this.convert = 1
        break
      case 2:
        this.reward.amount = this.rewardValueArray[1]
        break
      default:
        break
    }
    this.reward.amount = isNaN(this.reward.amount) ? 0 : parseInt(this.reward.amount, 10)
    this.platform.callReactDeveloper({
      ...App.initData,
      ...this.h5Setting,
      campaign: this.currentOffer,
      nodeName: "dismissed",
      adShowTime: App.adShowTime,
      convert: this.convert,
      reward: this.reward,
    })
    // 调用自动load方法
    this.platform.callLoadAds({
      ...App.initData,
      campaign: this.currentOffer,
      nodeName: "dismissed",
    })
    this.hasBeenReward = true
    this.adCloseTimingReport() // 可能是关闭广告上报，待确认
    App.closeAd() // 关闭回调，ios需要，安卓不需要（奖励回调发出后，安卓会调用closeAd）
  }

  /**
   * 关闭视频播放模板并根据 campaign.video_end_type 决定如何走后续跳转
   */
  closeSingleVideoTemplateWithAutoJump() {

    // TODO 仅作为 video_end_type 跳转测试用，跳转测试没有问题后，移除即可
    // this.videoSkipResult == 2
    // this.currentOffer.video_end_type = 4

    if (this.videoSkipResult == 1) {
      this.closeAdWithBiz();
    } else {
      let sendCampaign = {}
      const videoEndType = (this.currentOffer.video_end_type && parseInt(this.currentOffer.video_end_type, 10)) || 0
      console.log('videoEndType', videoEndType)
      switch(videoEndType) {
        // 展示 endcard
        default: case 2:
          this.showEndcard()
          if (!this.offerHasChanged && this.rewardInfoIsNotNull) {
            const rewardAmount = this.rewardTimesCount == 0 ? this.rewardValueArray[0] : Math.min(App.initData.unitSetting.amount, App.initData.unitSetting.amount_max - App.initData.unitSetting.amount)
            if (rewardAmount > 0) {
              this.rpDialogHasMount = true
              const dataSend = {
                rewardAmount
              }
              Message.emitMessageToView(this.nextOfferChoice, 'setRewardNumber', dataSend)
              setTimeout(() => {
                this.slotIn('slot_2', this.nextOfferChoice)
              }, 1000)
              this.loadNextOffer()
            } else {
              this.nextOfferChoice.destory()
              this.dialogAmountNonPositiveTimingReport()
            }
          }
          break
        case 1:
          // 视频播放完直接走关闭广告逻辑，即：关闭视频，不显示end card，并触发onAdClose
          this.closeAdWithBiz()
          break
        // Todo 待SDK发版支持向第三方落地页注入关闭按钮后激活该逻辑
        // case 4:
        //   关闭视频、使用webview方式打开landing page、上报notice url、手动关闭触发onAdClose回调
        //   sendCampaign = {
        //     ...this.currentOffer
        //   }
        //   sendCampaign.click_mode = 6
        //   sendCampaign.link_type = 8
        //   this.platform.rewardJsInstall(sendCampaign)
        //   this.closeAdWithBiz()
        //   break
        case 5:
          // 关闭视频、使用browser方式打开landing page、上报notice url、触发onAdClose回调
          sendCampaign = {
            ...this.currentOffer
          }
          sendCampaign.click_mode = 6
          sendCampaign.link_type = 9
          this.platform.rewardJsInstall(sendCampaign)
          this.closeAdWithBiz();
          break
        // Todo 待SDK发版支持用户关闭storekit通知H5后激活该逻辑
        // case 6:
        //   // 视频播放结束后，不显示 endcard，只显示 storeKit（SDK 会在storeKit 加载失败时自动外跳 App Store），关闭广告
        //   sendCampaign = {
        //     ...this.currentOffer
        //   }
        //   this.platform.rewardJsInstall(sendCampaign)
        //   this.closeAdWithBiz()
        //   break
      }
    }
  }

  showEndcard() {
    console.log("准备调用endcardshow回调")
    // endcard展示
    this.platform.callReactDeveloper({
      ...App.initData,
      ...this.h5Setting,
      campaign:this.currentOffer,
      nodeName:"endcardShowSuccess",
      adShowTime:App.adShowTime
    })

    console.log('endcardshow上报')
    this.endcardShowTimingReport()

    if (this.endcardHasLoadedSuccess || this.endcardHasReady) {
      // 展示endcard
      this.currentOffer.getTemplate().hide()
      // this.currentOffer.getTemplate().removeSelf()
      this.slotInAndShow('slot_1', this.endcard)

      // 通知endcard被展示同时发送关键数据
      this.adShowedData.param.click_scale = window.devicePixelRatio
      Message.emitMessageToView(this.endcard, 'MTG_EndcardAdShow', this.adShowedData)
    } else {
      this.endcardShowFailedTimingReport()
      const nativeEc = new NativeEndcard({
        campaign: this.currentOffer,
        unitId: this.unit.id,
        unitSetting: this.unit.setting,
      })
      nativeEc.onCloseBtnClicked(() => {
        console.log('兜底ec关闭点击')
        this.closeAdWithBiz()
      })
      nativeEc.onClicked(() => {
        // Create for endcard click event
        console.log('native ec被点击')
        // endcard点击回调
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
          ...App.initData,
          ...this.h5Setting,
          campaign:this.currentOffer,
          nodeName:"clicked",
          adShowTime:App.adShowTime,
        })
        // this.clickTimingReport()
      })
      this.slotIn('slot_1', nativeEc)
      this.endcard.destory()
      this.tplContainer.destory()
      this.nextOfferChoice.destory()
    }
  }

  loadNextOffer() {
    this.tplContainer.onLoad((ret) => {
      if (ret.result == 1) {
        console.log('offer2 加载成功')
        this.nextOfferHasReady = true
      } else {
        console.log('offer2 加载失败', ret)
        this.rpDialogHasMount = false
        this.nextOfferChoice.destory()
      }
    })
    if (!this.campaignList || !this.campaignList[1]) {
      this.loadCEmptyTimingReport()
    }
    Webview.getLoadCampaignParams(this.campaignList[1].rv.template_url, [this.campaignList[1]], this.unit.id, this.unit.setting)
      .then(loadParams => {
        console.log('获取到第二个offer tpl：', loadParams)
        this.tplContainer.load(loadParams)
      })
  }

  switchToNextOffer() {
    this.rpDialogHasMount = false
    this.dialogClickTimingReport()
    const nextOffer = this.campaignList[this.campaignList.indexOf(this.currentOffer) + 1] || this.campaignList[0]
    this.slotOut('slot_2', this.nextOfferChoice)
    this.endcard.hide()

    // 更换offer
    console.log('change into next offer ====')
    this.currentOffer = nextOffer
    this.currentOffer.getTemplate = () => {
      return this.tplContainer
    }
    currentCampaign = nextOffer
    this.offerHasChanged = true

    // 关键变量重新初始化
    this.lastVideoPlayPercentage = 0
    this.hasRunOneTime = false
    this.muteReportHasSent = false
    this.unmuteReportHasSent = false
    this.endcardHasLoadedSuccess = false
    this.endcardHasReady = false
    this.popupHasShow = false
    this.convert = 2
    this.videoHasEndOrSkip = false
    // 清除offer1中未显示的ctabanner
    if (this.bannerTimerId) {
      clearTimeout(this.bannerTimerId)
      this.bannerTimerId = null
    }

    if (this.ctaBannerDelayTimerId) {
      clearTimeout(this.ctaBannerDelayTimerId)
      this.ctaBannerDelayTimerId = null
    }

    Message.emitMessageToView(this.currentOffer.getTemplate(), 'MTG_AdShow', this.adShowedData)
    Message.emitMessageToView(this.currentOffer.getTemplate(), 'resumePlay')

    if (this.videoInterType > 0) {
      setTimeout(() => {
        Message.emitMessageToView(this.currentOffer.getTemplate(), 'showCtaBanner')
      }, this.videoInterType * 1000)
    }

    // 显示offer2的video tpl
    this.slotInAndShow('slot_1', this.currentOffer.getTemplate())
    if (!this.campaignList || !this.campaignList[1]) {
      this.loadCEmptyTimingReport()
    }
    Webview.getLoadCampaignParams(this.currentOffer.endcard_url, [this.campaignList[1]], this.unit.id, this.unit.setting)
      .then(loadParams => {
        console.log('获取到offer2 Endcard：', loadParams)
        this.endcard.load(loadParams)
      })
  }

  /**
   * 到达视频可奖励进度，上报
   */
  canGiveRewardToUser(currentPercentage) {
    // 判断视频到达配置奖励回调的播放进度
    console.log("canGiveRewardToUser")
    console.log(currentPercentage)
    console.log("currentPercentage",currentPercentage)
    if(this.convert == 2 && Number(currentPercentage) >= Number(this.unit.setting.vdcmp)){
      console.log("this.unit.setting.vdcmp",this.unit.setting.vdcmp)
      console.log("当前播放进度为：",currentPercentage)
      console.log("当前播放进度大于等于this.unit.setting.vdcmp")
      this.rewardTimesCount = this.rewardTimesCount + 1
      this.convert = 1; // convert 置为1
      this.addRewardToServerTimingReport() //  满足奖励回调条件，则上报
    }
  }

  // 上报相关 - START
  /**
   * onlyImpression 上报
   */
  @report([presetOnlyImpression, presetPvUrls, presetBtShow])
  onlyImpressionTimingReport() {
    console.log('onlyImpression Timing Report')
  }

  /**
   * 点击安装上报
   */
  @report([{
    // 动态取值
    value: () => {
        return {currentCampaign}
    },
    action: reportBizAdTrackingClick
  }/*, presetBtClick*/])
  clickTimingReport() {
      console.log('click Timing Report')
  }

  /**
   * 视频播放首帧上报
   */
  @report([{
    // 动态取值
    value: () => {
        return {currentCampaign}
    },
    action: reportBizImpression
  }, {
      // 动态取值
      value: () => {
          return {currentCampaign}
      },
      action: reportBizAdTrackingImpression
  },])
  impressionTimingReport() {
      console.log('impression Timing Report')
  }

  @report([{
    // 动态取值
    value: function() {
        const currentRewardAmount = this.rewardTimesCount == 1 ? this.rewardValueArray[0] : Math.min(App.initData.unitSetting.amount, App.initData.unitSetting.amount_max - App.initData.unitSetting.amount)
        return {currentCampaign, currentRewardAmount}
    },
    action: reportBizAddRewardToServer
  }])
  addRewardToServerTimingReport() {
      console.log('addRewardToServer Timing Report')
  }

  @report([{
    // 动态取值
    value: () => {
        return {currentCampaign}
    },
    action: reportBizAdTrackingVideoStart
  }])
  videoStartTimingReport() {
      console.log('videoStart Timing Report')
  }

  @report([{
      // 动态取值
      value: () => {
          return {currentCampaign}
      },
      action: reportBizAdTrackingVideoFirstQuartile
  }])
  videoFirstQuartileTimingReport() {
      console.log('VideoFirstQuartile Timing Report')
  }

  @report([{
      // 动态取值
      value: () => {
          return {currentCampaign}
      },
      action: reportBizAdTrackingVideoMidpoint
  }])
  videoMidpointTimingReport() {
      console.log('videoMidpoint Timing Report')
  }

  @report([{
      // 动态取值
      value: () => {
          return {currentCampaign}
      },
      action: reportBizAdTrackingVideoThirdQuartile
  }])
  videoThirdQuartileTimingReport() {
      console.log('videoThirdQuartile Timing Report')
  }

  @report([{
      // 动态取值
      value: () => {
          return {currentCampaign}
      },
      action: reportBizAdTrackingVideoComplete
  }])
  videoCompleteTimingReport() {
      console.log('videoComplete Timing Report')
  }

  @report([{
    // 动态取值
    value: function () {
        return {currentCampaign: App.initData.campaignList[0]}
    },
    action: reportBizAdTrackingVideoClose
  }])
  videoCloseTimingReport() {
      console.log('videoClose Timing Report')
  }

  @report([{
    // 动态取值
    value: () => {
        return {currentCampaign}
    },
    action: reportBizAdTrackingVideoMute
  }])
  videoMuteTimingReport() {
      console.log('videoMute Timing Report')
  }

  @report([{
      // 动态取值
      value: () => {
          return {currentCampaign}
      },
      action: reportBizAdTrackingVideoUnmute
  }])
  videoUnmuteTimingReport() {
      console.log('videoUnmute Timing Report')
  }

  @report([{
    // 动态取值
    value: function () {
        return {currentCampaign}
    },
    action: reportBizAdTrackingEndcardShow
  }])
  endcardShowTimingReport() {
      console.log('endcardShow Timing Report')
  }

  @report([presetBtClose])
  adCloseTimingReport() {
      console.log('adClose Timing Report')
  }

  @report([presetBtRPDialogExpand])
  dialogExpandTimingReport() {
      console.log('RPDialogExpand Timing Report')
  }

  @report([presetBtRPDialogClick])
  dialogClickTimingReport() {
      console.log('RPDialogClick Timing Report')
  }

  @report([presetBtRPDialogCollapse])
  dialogCloseManualTimingReport() {
      console.log('RPDialogCollapse Timing Report')
  }

  @report([presetBtRPDialogFailedClose])
  dialogCloseAutoTimingReport() {
      console.log('RPDialogFailedClose Timing Report')
  }

  @report([presetBtAdShowFailed])
  adShowFailedTimingReport() {
      console.log('adShowFailed Timing Report')
  }

  @report([presetBtEndcardShowFailed])
  endcardShowFailedTimingReport() {
      console.log('endcardShowFailed Timing Report')
  }

  @report([presetBtWebviewTerminate])
  webviewTerminateTimingReport() {
      console.log('webviewTerminate Timing Report')
  }

  @report([presetBtInitSDKVersionEmpty])
  initSDKVersionEmptyTimingReport() {
      console.log('initSDKVersionEmpty Timing Report')
  }

  // init 获取到 campaignList 时上报此埋点
  // （cLength 为获取到的 campaignList 长度）
  @report([{
    // 埋点上报
    value: function() {
      const cids = []
      window.initData.campaignList && window.initData.campaignList.forEach(c => c && c.id && cids.push(c.id))
      return {
        reportType: 'btInitCLength',
        dataCustomized: {
          // 从 SDK 获取到的 campaign 长度
          cLength: window.initData.campaignList && window.initData.campaignList.length,
          // campaignList 中所有的 campaign.id 列表，以逗号分割
          cids: cids.join(',')
        }
      }
    },
    action: reportNonBizData
  }])
  initCLengthTimingReport() {
      console.log('initCLength Timing Report')
  }

  // 在 webviewLoad 时大模板发现要传的 campaignList[0/1] 为 null 时上报此埋点
  @report([{
    // 埋点上报
    value: function() {
      const cids = []
      this.campaignList && this.campaignList.forEach(c => c && c.id && cids.push(c.id))
      return {
        reportType: 'btLoadCEmpty',
        dataCustomized: {
          cLength: this.campaignList && this.campaignList.length,
          // campaignList 中所有的 campaign.id 列表，以逗号分割
          cids: cids.join(',')
        }
      }
    },
    action: reportNonBizData
  }])
  loadCEmptyTimingReport() {
      console.log('loadCEmpty Timing Report')
  }

  // 在 webviewLoad 时大模板发现要传的 campaignList[0/1] 为 null 时上报此埋点
  @report([{
    // 埋点上报
    value: function() {
      return {
        reportType: 'btRPDialogAmountNonPositive',
        dataCustomized: {
          amountMax: App.initData.unitSetting.amount_max,
          amount: App.initData.unitSetting.amount,
        }
      }
    },
    action: reportNonBizData
  }])
  dialogAmountNonPositiveTimingReport() {
      console.log('loadCEmpty Timing Report')
  }
  // 上报相关 - END

  /**
   * 销毁组件
   */
  destory() {
    super.destory()
    this.currentOffer.getTemplate() && this.currentOffer.getTemplate().destory()
    this.nextOfferChoice && this.nextOfferChoice.destory()
    this.endcard && this.endcard.destory()
  }

  /**
   * 子类需要重写该方法，以判断模板的是否成功加载
   * @returns {Promise}
   */
  _isLoadFinish(){
    const promise = Promise.all([
      super._isLoadFinish(),
      this.currentOffer.getTemplate().whenCampaignReady(),
      this.nextOfferChoice.whenCampaignReady(),
    ])
    promise.then(() => {
      if (this.videoInterType != 0) {
        Message.emitMessageToView(this.currentOffer.getTemplate(), 'hideCtaBanner')
      }
      console.log('tpl load 成功')
    }).catch(e=>{
      console.log('tpl load 失败', e)
    })
    return promise
  }
}